module.exports = __webpack_public_path__ + "img/city-3.05f98a02.png";